import { useState } from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger, cn } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';

/**
 * Info icon with a field description. Opens on hover and focus like any tooltip, and also on
 * tap/click: Radix tooltips ignore touch and close on click, so mobile could not read it.
 */
export function FieldDescriptionTip({
  label,
  description,
  side = 'top',
  className,
}: {
  label: string;
  description: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={cn('text-muted-foreground shrink-0', className)}
          aria-label={dashboardT('reportExplorer.selection.description', { label })}
          onClick={(event) => {
            // Keeps Radix from closing the tooltip on click.
            event.preventDefault();
            setOpen(true);
          }}
        >
          <Info className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-64">
        {description}
      </TooltipContent>
    </Tooltip>
  );
}
